"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagStore = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const timsort_1 = require("timsort");
const services_1 = require("../services");
function tagSort(summaryA, summaryB) {
    if (summaryA.updatedAt < summaryB.updatedAt) {
        return 1;
    }
    else if (summaryA.updatedAt > summaryB.updatedAt) {
        return -1;
    }
    return 0;
}
class TagStore {
    constructor() {
        this.lastFetch = null;
    }
    get fetched() {
        const rest = services_1.Services.Department.rest;
        return rest.tags.hasFetched;
    }
    fetch(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const rest = services_1.Services.Department.rest;
            yield rest.tags.fetch();
            return this.get(id);
        });
    }
    get(id) {
        if (id == null) {
            return null;
        }
        const rest = services_1.Services.Department.rest;
        if (this.lastFetch == null || (this.lastFetch + TagStore.FETCH_TIME) < Date.now()) {
            this.refresh();
        }
        let tag = rest.tags.find('objectId', id);
        // Old tags have different 'objectId' and 'uuid' values
        if (tag == null) {
            tag = rest.tags.find('uuid', id);
        }
        return tag;
    }
    get all() {
        if (services_1.Services.Department.current == null) {
            return null;
        }
        const tags = services_1.Services.Department.rest.tags.value;
        if (tags == null) {
            return [];
        }
        (0, timsort_1.sort)(tags, tagSort);
        return tags;
    }
    refresh() {
        this.lastFetch = Date.now();
        return services_1.Services.Department.rest.tags.refetch();
    }
}
exports.TagStore = TagStore;
TagStore.FETCH_TIME = 60 * 1000;
tslib_1.__decorate([
    mobx_1.computed
], TagStore.prototype, "all", null);
//# sourceMappingURL=tag.store.js.map